const odometer = () => {
  const targetAreas = document.querySelectorAll('.target-area');
  if (targetAreas.length === 0) return;

  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const container = entry.target;
          obs.unobserve(container);
          const statNumbers = container.querySelectorAll('.stat-number');

          statNumbers.forEach((el: Element, index: number) => {
            const htmlEl = el as HTMLElement;
            const target = Number(htmlEl.dataset.target);
            let step = 0;

            setTimeout(() => {
              const circleItem = htmlEl.closest('.stat-item');
              if (circleItem) circleItem.classList.add('pop-active');

              const timer = setInterval(() => {
                step++;
                htmlEl.innerText = Math.floor(
                  target * (step / 30),
                ).toLocaleString();

                if (step >= 30) {
                  htmlEl.innerText = target.toLocaleString();
                  clearInterval(timer);
                }
              }, 26);
            }, index * 400);
          });
        }
      });
    },
    {
      rootMargin: '0px 0px -33% 0px',
    },
  );

  targetAreas.forEach((el) => observer.observe(el));
};

export default odometer;
